import { render, staticRenderFns } from "./RatesForm.vue?vue&type=template&id=3deac858&scoped=true"
import script from "./RatesForm.vue?vue&type=script&lang=js"
export * from "./RatesForm.vue?vue&type=script&lang=js"
import style0 from "./RatesForm.vue?vue&type=style&index=0&id=3deac858&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deac858",
  null
  
)

export default component.exports